import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { EmailTask } from './email-task'
import { EmailTaskSerializer } from './email-task.serializer'

@Injectable()
export class EmailTaskService extends ResourceService<EmailTask> {
  constructor(
    public http: HttpClient,
    emailTaskSerializer: EmailTaskSerializer
  ) {
    super(http, `${environment.backendApiUrl}/email-tasks`, emailTaskSerializer)
  }
}
